module.exports = __webpack_public_path__ + "static/media/followed-react.337f5b14.svg";